import { createContext } from 'react';

/**
 * @typedef {Object} AppContextValue
 * @property {boolean} isInWebView
 * @property {*} currentUser
 * @property {*} serviceDesk
 * @property {(string|null)} [jiraBrowseBase] Browse base of the active Jira instance (from the backend's JSM_DOMAIN); optional — falls back to prod when absent.
 */

/** @type {import('react').Context<AppContextValue>} */
const AppContext = createContext({ isInWebView: false, currentUser: null, serviceDesk: null, jiraBrowseBase: null });

export default AppContext;
